<template>
  <div>
    <p>{{ minute }}:{{ second }}</p>
  </div>
</template>

<script type="text/ecmascript-6">

export default {

data() {

return {
timmer:false,
minutes:10,
seconds:0,
time:null

      }

},
created(){
    this.timmer = this.$props.module
    this.add()

},
props:{
    "module":{}
},
methods: {

num:function (n) {

return n <10 ?'0' + n :'' + n

},

add() {
var _this =this
if(this.timmer){
     var time = window.setInterval(function () {
    if (_this.seconds ===0 && _this.minutes !==0) {
        _this.seconds =59
        _this.minutes -=1
      }else if (_this.minutes ===0 && _this.seconds ===0) {
        _this.seconds =0
        window.clearInterval(time)
        this.chongzhi()

        }else {
        _this.seconds -=1
          }
          },1000)
          this.time = time
}else{
     window.clearInterval(this.time)

     this.chongzhi()
}

},
pause(){

},
chongzhi() {
        this.timmer = false
        this.minutes =10
        this.seconds =0

      },

},

watch: {

second: {

handler(newVal) {
this.num(newVal)
}

},

minute: {
handler(newVal) {
this.num(newVal)
}

}

},

computed: {

second:function () {

return this.num(this.seconds)

},

minute:function () {

return this.num(this.minutes)

}

}

}
</script>

<style></style>
